import { render, staticRenderFns } from "./OrderFabricReadyExtraProcessTypeTable.vue?vue&type=template&id=04d33412&"
import script from "./OrderFabricReadyExtraProcessTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricReadyExtraProcessTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderFabricReadyExtraProcessTypeTable.vue?vue&type=style&index=0&id=04d33412&prod&lang=scss&"
import style1 from "./OrderFabricReadyExtraProcessTypeTable.vue?vue&type=style&index=1&id=04d33412&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports